const postKeys = {
  base: ["posts"],
  lists: () => [...postKeys.base, "list"] as const,
  list: (params?: URLSearchParams) =>
    [...postKeys.lists(), params?.toString()] as const,
  details: () => [...postKeys.base, "detail"] as const,
  detail: (id?: string) => [...postKeys.details(), id] as const,
};

export { postKeys };
